<template>
  <div class="clearfix">
    <a-upload
        :action="action"
        :headers="headers"
        list-type="picture-card"
        :fileList="myFileList"
        @preview="handlePreview"
        @change="handleChangeLive"
        :remove="removeImg"
    >
      <div>
        <a-icon type="plus" />
        <div class="ant-upload-text">
          上传
        </div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
  import api from '@/services/api';

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

export default {
  components: {
    // categoryTableModal
  },
  props:{
    fileList: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      myFileList:[],
      action: api.temp.UPLOAD_PATH,
      headers: {
        token: localStorage.getItem('token') || ''
      },
      previewVisible: false,
      previewImage: '',
    }
  },
  created() {
    this.myFileList = this.fileList
  },
  watch: {
    fileList: function (newQuestion) {
      this.myFileList = newQuestion
    }
  },
  async mounted() {

  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChangeLive(info) {
      this.myFileList = info.fileList
      this.$emit('change', info)
    },
    removeImg(value){
      console.log(this.myFileList);
      this.myFileList.forEach((item,index)=>{
        if(item.uid === value.uid){
          this.myFileList.splice(index,1)
        }
      })
      console.log(this.myFileList);
      this.$emit('remove', value)
    },
  }
}
</script>

<style scoped>
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
/deep/.vxe-toolbar {
  padding-left: 0
}
</style>
